module.exports = __webpack_public_path__ + "static/media/logo.2705e3e4.svg";